/**
 * NZ collection flavour filter — client-side grid filtering with URL sync.
 * Format (Cans / Glass Bottles) remains server-side via Shopify collection tags.
 */
(function () {
  var FILTER_FLAVOURS = ['watermelon', 'cherry', 'pear', 'strawberry', 'mango'];
  var FLAVOUR_LABELS = {
    all: 'All',
    watermelon: 'Watermelon',
    cherry: 'Cherry',
    pear: 'Pear',
    strawberry: 'Strawberry',
    mango: 'Mango',
  };

  var FLAVOUR_HANDLES = {
    watermelon: 'sidekick-watermelon-soda-12-pack',
    sober: 'the-sober-july-24-pack',
  };

  function normalizeFlavour(value) {
    if (!value) return 'all';
    var key = String(value).toLowerCase().trim();
    return FILTER_FLAVOURS.indexOf(key) >= 0 ? key : 'all';
  }

  function getFlavourFromTags(tagString) {
    if (!tagString) return null;
    var tags = String(tagString).toLowerCase().split(',');
    for (var i = 0; i < FILTER_FLAVOURS.length; i++) {
      var key = FILTER_FLAVOURS[i];
      for (var t = 0; t < tags.length; t++) {
        if (tags[t].trim() === key) return key;
      }
    }
    return null;
  }

  function getCardHandle(card, item) {
    if (item && item.getAttribute('data-product-handle')) {
      return item.getAttribute('data-product-handle');
    }
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var match = String(link.getAttribute('href')).match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  function detectFlavour(card, item) {
    var fromTags = getFlavourFromTags(item ? item.getAttribute('data-product-tags') : '');
    if (fromTags) return fromTags;

    var handle = getCardHandle(card, item);
    if (handle === FLAVOUR_HANDLES.sober) return 'sober';
    if (handle === FLAVOUR_HANDLES.watermelon) return 'watermelon';

    var titleLink = card.querySelector('a[ref="productTitleLink"]');
    var heading = titleLink ? titleLink.querySelector('h1, h2, h3, h4, h5, h6') : null;
    var title = heading ? (heading.textContent || '').trim() : '';
    if (!title) return null;

    if (/watermelon/i.test(title)) return 'watermelon';
    if (/cherry/i.test(title)) return 'cherry';
    if (/pear/i.test(title)) return 'pear';
    if (/strawberry/i.test(title)) return 'strawberry';
    if (/mango/i.test(title)) return 'mango';
    if (/sober/i.test(title)) return 'sober';
    return null;
  }

  function readFormatFromPath() {
    var path = window.location.pathname.replace(/\/$/, '');
    if (/\/cans$/i.test(path)) return 'cans';
    if (/\/glass-bottles$/i.test(path)) return 'glass-bottles';
    return '';
  }

  function readFormatFromUrl() {
    var param = new URL(window.location.href).searchParams.get('format');
    if (param === 'cans' || param === 'glass-bottles') return param;
    return readFormatFromPath();
  }

  function readFlavourFromUrl() {
    return normalizeFlavour(new URL(window.location.href).searchParams.get('flavour'));
  }

  function getActiveFormatLabel() {
    var activeTag = document.querySelector('[class*="ai-tag-filter__tag-"].active [class*="ai-tag-filter__tag-label-"]');
    if (activeTag) return activeTag.textContent.trim();
    var format = readFormatFromUrl();
    if (format === 'cans') return 'Cans';
    if (format === 'glass-bottles') return 'Glass Bottles';
    return '';
  }

  function mount(resultsList) {
    if (!resultsList || resultsList.dataset.skFlavourFilterInit === 'true') return;
    if (document.body.classList.contains('us-showcase')) return;

    var pills = resultsList.querySelector('.fc-flavour-pills[data-flavour-filter]');
    if (!pills) return;

    var emptyStateId = resultsList.getAttribute('data-sk-empty-state-id');
    var emptyState = emptyStateId ? document.getElementById(emptyStateId) : null;
    var countEl = resultsList.querySelector('.fc-flavour-filter-count');
    var promoBanner = resultsList.querySelector('.collection-promo-banner');
    var activeFlavour = 'all';

    function syncFormatFilterLinks(flavour, format) {
      document.querySelectorAll('[class*="ai-tag-filter-"] a[class*="ai-tag-filter__tag-"]').forEach(function (link) {
        try {
          var url = new URL(link.href, window.location.origin);
          if (!flavour || flavour === 'all') {
            url.searchParams.delete('flavour');
          } else {
            url.searchParams.set('flavour', flavour);
          }
          if (format) {
            url.searchParams.set('format', format);
          } else {
            url.searchParams.delete('format');
          }
          link.setAttribute('href', url.pathname + url.search);
        } catch (e) {}
      });
    }

    function updateUrl(flavour, replace) {
      var url = new URL(window.location.href);
      var format = readFormatFromPath();

      if (!flavour || flavour === 'all') {
        url.searchParams.delete('flavour');
      } else {
        url.searchParams.set('flavour', flavour);
      }

      if (format) {
        url.searchParams.set('format', format);
      } else {
        url.searchParams.delete('format');
      }

      var next = url.pathname + url.search + url.hash;
      var current = window.location.pathname + window.location.search + window.location.hash;
      if (next === current) {
        syncFormatFilterLinks(flavour, format);
        return;
      }

      if (replace) {
        window.history.replaceState({ flavour: flavour, format: format }, '', next);
      } else {
        window.history.pushState({ flavour: flavour, format: format }, '', next);
      }
      syncFormatFilterLinks(flavour, format);
    }

    function setActiveChip(flavour) {
      pills.querySelectorAll('[data-flavour]').forEach(function (chip) {
        var isActive = chip.dataset.flavour === flavour;
        chip.classList.toggle('is-active', isActive);
        if (chip.matches('button')) {
          chip.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        }
        if (isActive && window.matchMedia('(max-width: 749px)').matches) {
          chip.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      });
    }

    function updateCount(visible) {
      if (!countEl) return;
      if (!activeFlavour || activeFlavour === 'all') {
        countEl.hidden = true;
        countEl.textContent = '';
        return;
      }
      countEl.hidden = false;
      countEl.textContent = visible === 1 ? '1 product' : visible + ' products';
    }

    function updateFacetsCount(visible) {
      var facetsCount = resultsList.querySelector('.products-count-wrapper span');
      if (!facetsCount) return;
      if (pills.dataset.originalFacetsCount == null) {
        pills.dataset.originalFacetsCount = facetsCount.textContent;
      }
      if (!activeFlavour || activeFlavour === 'all') {
        facetsCount.textContent = pills.dataset.originalFacetsCount;
        return;
      }
      facetsCount.textContent = visible === 1 ? '1 item' : visible + ' items';
    }

    function updatePromoBanner(flavour) {
      if (!promoBanner) return;
      promoBanner.hidden = !!(flavour && flavour !== 'all' && flavour !== 'watermelon');
    }

    function updateEmptyState(flavour, visible) {
      if (!emptyState) return;
      if (!flavour || flavour === 'all' || visible > 0) {
        emptyState.hidden = true;
        return;
      }
      var formatLabel = getActiveFormatLabel();
      var flavourLabel = FLAVOUR_LABELS[flavour] || flavour;
      var format = readFormatFromUrl();
      var text;
      if (flavour === 'watermelon' && format === 'glass-bottles') {
        text = 'Watermelon isn’t in glass yet — try cans, or pick another flavour.';
      } else if (formatLabel) {
        text = 'No ' + flavourLabel + ' products in ' + formatLabel + ' right now.';
      } else {
        text = 'No ' + flavourLabel + ' products right now.';
      }
      var textNode = emptyState.querySelector('.collection-flavour-empty__text');
      if (textNode) textNode.textContent = text;
      emptyState.hidden = false;
    }

    /** Hide flavour pills with zero matches in the active format (e.g. Watermelon × Glass). */
    var syncingPills = false;
    function syncFlavourPillAvailability() {
      if (syncingPills) return;
      syncingPills = true;

      var items = resultsList.querySelectorAll('.product-grid__item:not(.product-grid__item--promo)');
      var counts = {};
      FILTER_FLAVOURS.forEach(function (key) {
        counts[key] = 0;
      });

      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        var card = item.querySelector('.product-card');
        if (!card) continue;
        var itemFlavour = card.dataset.flavour || detectFlavour(card, item);
        if (itemFlavour && counts[itemFlavour] != null) {
          counts[itemFlavour] += 1;
          card.dataset.flavour = itemFlavour;
        }
      }

      var resetToAll = false;
      pills.querySelectorAll('[data-flavour]').forEach(function (chip) {
        var key = chip.dataset.flavour;
        if (!key || key === 'all') {
          chip.hidden = false;
          chip.removeAttribute('aria-hidden');
          return;
        }
        var available = (counts[key] || 0) > 0;
        chip.hidden = !available;
        chip.setAttribute('aria-hidden', available ? 'false' : 'true');
        if (!available && key === activeFlavour) resetToAll = true;
      });

      syncingPills = false;
      if (resetToAll && activeFlavour !== 'all') {
        applyFlavourFilter('all', { replaceUrl: true, skipPillSync: true });
        syncFlavourPillAvailability();
      }
    }

    function setItemVisible(item, show) {
      item.classList.toggle('sk-flavour-hidden', !show);
      item.hidden = !show;
      item.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    function applyFlavourFilter(flavour, options) {
      options = options || {};
      activeFlavour = normalizeFlavour(flavour);

      var items = resultsList.querySelectorAll('.product-grid__item:not(.product-grid__item--promo)');
      var visible = 0;

      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        var card = item.querySelector('.product-card');
        if (!card) {
          setItemVisible(item, activeFlavour === 'all');
          if (activeFlavour === 'all') visible++;
          continue;
        }

        var itemFlavour = card.dataset.flavour || detectFlavour(card, item);
        if (itemFlavour) {
          card.dataset.flavour = itemFlavour;
          card.classList.add('is-flavour-' + itemFlavour);
        }

        var show = activeFlavour === 'all' || (itemFlavour && itemFlavour === activeFlavour);
        setItemVisible(item, show);
        if (show) visible++;
      }

      setActiveChip(activeFlavour);
      updateCount(visible);
      updateFacetsCount(visible);
      updateEmptyState(activeFlavour, visible);
      updatePromoBanner(activeFlavour);
      if (!options.skipPillSync) {
        syncFlavourPillAvailability();
      }

      if (!options.skipUrl) {
        updateUrl(activeFlavour, !!options.replaceUrl);
      }
    }

    pills.addEventListener('click', function (event) {
      var chip = event.target.closest('[data-flavour]');
      if (!chip || !pills.contains(chip)) return;
      event.preventDefault();
      event.stopPropagation();
      applyFlavourFilter(chip.dataset.flavour);
    });

    if (emptyState) {
      var clearBtn = emptyState.querySelector('.collection-flavour-empty__clear');
      if (clearBtn) {
        clearBtn.addEventListener('click', function () {
          applyFlavourFilter('all');
        });
      }
    }

    window.addEventListener('popstate', function () {
      applyFlavourFilter(readFlavourFromUrl(), { skipUrl: true });
    });

    resultsList.dataset.skFlavourFilterInit = 'true';
    applyFlavourFilter(readFlavourFromUrl(), { replaceUrl: true });
    syncFormatFilterLinks(readFlavourFromUrl(), readFormatFromPath());

    resultsList.skApplyFlavourFilter = applyFlavourFilter;
  }

  function initAll() {
    document.querySelectorAll('results-list[data-sk-flavour-filter]').forEach(mount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.addEventListener('load', initAll);

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    var resultsList = event.target.querySelector('results-list[data-sk-flavour-filter]');
    if (resultsList) {
      resultsList.dataset.skFlavourFilterInit = '';
      mount(resultsList);
    }
  });

  document.addEventListener('pack-style:update', function () {
    initAll();
    document.querySelectorAll('results-list[data-sk-flavour-filter]').forEach(function (list) {
      if (typeof list.skApplyFlavourFilter === 'function') {
        list.skApplyFlavourFilter(readFlavourFromUrl(), { skipUrl: true });
      }
    });
  });
})();
